import { render, staticRenderFns } from "./ServiceEndpoint.vue?vue&type=template&id=0a3fd918&"
import script from "./ServiceEndpoint.vue?vue&type=script&lang=js&"
export * from "./ServiceEndpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3fd918')) {
      api.createRecord('0a3fd918', component.options)
    } else {
      api.reload('0a3fd918', component.options)
    }
    module.hot.accept("./ServiceEndpoint.vue?vue&type=template&id=0a3fd918&", function () {
      api.rerender('0a3fd918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serviceDetails/ServiceEndpoint.vue"
export default component.exports